<template>
  <div>
    <h1>Furniture Page</h1>
    <p>Content for Furniture.</p>
  </div>
</template>

<script>
export default {
  name: 'Furniture'
}
</script>

<style>
/* 添加样式 */
</style>
